import { render, staticRenderFns } from "./autotimer.vue?vue&type=template&id=b52a707e"
import script from "./autotimer.vue?vue&type=script&lang=js"
export * from "./autotimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports